import { apiRequest, readJsonOrThrow, parseJsonResponse } from "@/api/client";

export async function fetchSocialProfile(session) {
  const response = await apiRequest("/momo/social/profile/me", {
    session,
  });
  if (response.status === 404) {
    return null;
  }
  return readJsonOrThrow(response, "Failed to fetch social profile");
}

export async function fetchFacebookPageId(session) {
  const response = await apiRequest("/momo/social/facebook-page-id", {
    session,
  });
  if (response.status === 404) {
    return { page_id: "" };
  }
  return readJsonOrThrow(response, "Failed to fetch Facebook Page ID");
}

export async function updateFacebookPageId(session, pageId) {
  const response = await apiRequest("/momo/social/facebook-page-id", {
    method: "PATCH",
    session,
    body: { page_id: String(pageId || "").trim() },
  });
  return readJsonOrThrow(response, "Failed to update Facebook Page ID");
}

export async function fetchFacebookPages(session) {
  const response = await apiRequest("/momo/social/facebook-pages", {
    session,
  });
  return readJsonOrThrow(response, "Failed to fetch Facebook pages");
}

export async function connectSocialProfile(session, payload) {
  const response = await apiRequest("/momo/social/connect", {
    method: "POST",
    session,
    body: payload,
  });
  return parseJsonResponse(response);
}
